import { FOOTER } from "@/constants/testIds";

const EXPLORE = [
  { key: "shift", label: "The Shift", href: "#shift" },
  { key: "whatwedo", label: "What We Do", href: "#whatwedo" },
  { key: "whynow", label: "Why Now", href: "#whynow" },
  { key: "plans", label: "How We Work", href: "#plans" },
  { key: "privacy", label: "Privacy", href: "#privacy" },
  { key: "faq", label: "FAQ", href: "#faq" },
];

const LEGAL = [
  { key: "privacy-page", label: "Privacy" },
  { key: "terms-page", label: "Terms" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const onAnchor = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#ffffff] border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6 mb-16 md:mb-20">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src="/arvios-vault-logo.svg"
                alt="Arvios Vault"
                className="h-7 md:h-8 w-auto"
              />
            </div>
            <p className="font-serif text-2xl md:text-3xl leading-snug tracking-tight max-w-md text-[#0a0a0a]">
              AI-augmented BPO for industries that can't afford mistakes.
            </p>
            <a
              href="#book"
              data-testid={FOOTER.cta}
              onClick={(e) => onAnchor(e, "#book")}
              className="mt-8 btn-primary"
            >
              Book a call
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <div className="font-mono text-[12px] uppercase tracking-[0.3em] text-black/65 mb-6">
              Explore
            </div>
            <ul className="space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.key}>
                  <a
                    href={l.href}
                    data-testid={FOOTER.link(l.key)}
                    onClick={(e) => onAnchor(e, l.href)}
                    className="font-sans text-black/70 hover:text-black transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2 md:col-start-10">
            <div className="font-mono text-[12px] uppercase tracking-[0.3em] text-black/65 mb-6">
              Company
            </div>
            <ul className="space-y-3">
              <li>
                <a
                  href="#book"
                  data-testid={FOOTER.link("book")}
                  onClick={(e) => onAnchor(e, "#book")}
                  className="font-sans text-black/70 hover:text-black transition-colors"
                >
                  Book a call
                </a>
              </li>
              <li>
                <a
                  href="mailto:avery@arvios.com"
                  data-testid={FOOTER.link("email")}
                  className="font-sans text-black/70 hover:text-black transition-colors"
                >
                  avery@arvios.com
                </a>
              </li>
            </ul>

            <div className="mt-8 font-mono text-[12px] uppercase tracking-[0.3em] text-black/65 mb-4">
              Legal
            </div>
            <ul className="space-y-3">
              {LEGAL.map((l) => (
                <li key={l.key}>
                  <a
                    href="#"
                    data-testid={FOOTER.link(l.key)}
                    className="font-sans text-black/70 hover:text-black transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-black/12 pt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 font-mono text-[12px] uppercase tracking-[0.22em] text-black/60">
          <div>© {year} Arvios · Florida, USA</div>
          <div className="text-black/65">
            An American company. Healthcare-, legal- and finance-grade by default.
          </div>
        </div>
      </div>
    </footer>
  );
}
